import { Inject } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { animate, style, transition, trigger } from "@angular/animations";
import { DataService } from "../../../../services/data.service";
import { UserActionEnum } from "../../../../common/manage-permission";

@Component({
  selector: "app-reject-resource-permissions-dialog",
  templateUrl: "./reject-resource-permissions-dialog.component.html",
  styleUrls: ["./reject-resource-permissions-dialog.component.scss"],
  animations: [
    trigger("dialog", [
      transition("void => *", [
        style({ transform: "scale3d(.3, .3, .3)" }),
        animate(100),
      ]),
      transition("* => void", [
        animate(100, style({ transform: "scale3d(.0, .0, .0)" })),
      ]),
    ]),
  ],
})
export class RejectResourcePermissionsDialogComponent implements OnInit {
  public permissionRejectReason: string = "";

  constructor(
    public dataService: DataService,
    private dialogRef: MatDialogRef<RejectResourcePermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  onCancel() {
    this.dialogRef.close({
      action: UserActionEnum.CANCEL,
      permissionRejectReason: this.permissionRejectReason,
    });
  }

  onSubmit() {
    this.dialogRef.close({
      action: UserActionEnum.SUBMIT,
      permissionRejectReason: this.permissionRejectReason,
    });
  }
}
